import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import  CertReqUniqueNoModel  from "../../models/certreqUniqueNo";
import BFileInput from "../../helpers/bfile-input";
import BCamInput from "../../helpers/bcam-input";
class CertUniqueNoModal  extends Component {
    constructor() {
        super();
    
        this.state = {
          modalIsOpen: false,
          model:{
            CertReqId:null,
            
          }
          
        };
    
        this.openModal = this.openModal.bind(this);
       
        this.closeModal = this.closeModal.bind(this);
        this.submit=this.submit.bind(this);
        this.refreshModel= this.refreshModel.bind(this);
        this._handleKeyPress=this._handleKeyPress.bind(this);
        
      }
    
      openModal(id) {
        const {model}=this.state;
        model.CertReqId=id;
       
        this.setState({modalIsOpen: true,model:model});
      }
     
     
      closeModal() {
        this.setState({modalIsOpen: false});
        
      }

      submit(){
        const {model}=this.state;  
        this.props.submitUniqueNoHandler(model);
        this.closeModal();
      }
      
      
      getData() {
          let model = new CertReqUniqueNoModel(this.refs);
          return model;
      }
      _handleKeyPress(e) {
       //console.log(e.key);

        if (e.key === 'Enter') {
            this.submit();
            e.preventDefault();
        }

    }

      refreshModel () {
        let _model = new CertReqUniqueNoModel(this.refs);  
        this.setState({

            model:_model

        });

           
      }
     
    
      render() {
        const {model} = this.state;
        return (
           <Modal style={{opacity:1}} show={this.state.modalIsOpen} onHide={this.closeModal} centered size="md" aria-labelledby="contained-modal-title-vcenter" >
 
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                  تخصیص شماره گواهی
                </Modal.Title>
            </Modal.Header>    
            <Modal.Body>
              <div className="form-horizontal">
                      <div class="form-group">
                          <label class="control-label col-sm-3" for="email">شماره گواهی</label>
                          <div class="col-sm-9">
                              <input  onKeyPress={(e) => this._handleKeyPress(e)} className="form-control"  autoFocus   value={model && model.UniqueNo } onChange={this.refreshModel} type="number" name="UniqueNo" ref="UniqueNo"  />
                          </div>
                      </div>
                     
              </div>
              <input type="hidden" ref="CertReqId" name="CertReqId" value={model && model.CertReqId}></input>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeModal}>
                انصراف
              </Button>
              <Button variant="primary" onClick={this.submit}>
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
        );
      }
}

 
export default CertUniqueNoModal;